var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// React Imports
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactCodeInput from 'react-auth-code-input';
import { useLazyQuery } from '@apollo/client';
// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
// local imports
import defaultLogo from 'assets/images/logo--white.svg';
import defaultBackgroundLogo from 'assets/images/logo--white--solo.svg';
import LoginContainer from 'components/containers/login-container/login-container';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
import useAuthentication from 'hooks/use-authentication';
import useTinySettings from 'hooks/use-tiny-settings';
import useNavigateForCompletedExam from 'hooks/use-navigate-exam-completed';
import useLogger from 'hooks/use-logger';
import EXAM_ATTEMPT_QUERY from 'queries/exam-attempt.graphql';
import GET_USER_QUERY from 'queries/get-user.graphql';
import { getAccountWithToken } from 'services/api/account';
import { saveAccountIdToStorage, getCustomBrandingFromStorage, clearCustomBranding } from 'helpers/customBranding';
// import { S2BInformationData } from 'services/s2b/types'; [CHECK validateExam FUNCTION FOR INFORMATION ABOUT THIS COMMENTS]
// import S2BIntegrationService from 'services/s2b/s2b'; [CHECK validateExam FUNCTION FOR INFORMATION ABOUT THIS COMMENTS]
// import useVerifyS2BBrowser from 'hooks/use-verify-browser'; [CHECK validateExam FUNCTION FOR INFORMATION ABOUT THIS COMMENTS]
const LoginPage = () => {
    const [codeIsValid, setCodeIsValid] = useState(true);
    const [code, setCode] = useState('');
    const [credentialsError, setCredentialsError] = useState('');
    const [examTitle, setExamTitle] = useState('Welcome to sumadi exam login');
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState(defaultLogo);
    const [backgroundLogo, setBackgroundLogo] = useState(defaultBackgroundLogo);
    const authInputRef = useRef(null);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    // const { onS2bBrowser } = useVerifyS2BBrowser(); [CHECK validateExam FUNCTION FOR INFORMATION ABOUT THIS COMMENTS]
    const { register, handleSubmit, formState: { errors }, } = useForm();
    const location = useLocation();
    const { setMarketplace } = useTinySettings();
    const { redirectIfCompleted } = useNavigateForCompletedExam(undefined);
    const { createSession, isLoggedIn, getUserIdFromToken, getExamIdFromToken, getSessionEmail } = useAuthentication();
    const [examAttemptData] = useLazyQuery(EXAM_ATTEMPT_QUERY, {
        fetchPolicy: 'network-only',
    });
    const [getUser] = useLazyQuery(GET_USER_QUERY, {
        fetchPolicy: 'network-only',
    });
    // [CHECK validateExam FUNCTION FOR INFORMATION ABOUT THIS COMMENTS]
    // const [getS2BInformation] = useLazyQuery<{ s2bInformation: S2BInformationData }>(GET_S2B_INTEGRATION, {
    //   fetchPolicy: 'network-only',
    // });
    const logger = useLogger();
    useEffect(() => {
        const customBranding = getCustomBrandingFromStorage();
        (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) && (customBranding === null || customBranding === void 0 ? void 0 : customBranding.logoWhite) && setLogo(customBranding.logoWhite);
        (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) && (customBranding === null || customBranding === void 0 ? void 0 : customBranding.logo) && setBackgroundLogo(customBranding.logo);
    }, []);
    useEffect(() => {
        if (isLoggedIn()) {
            navigate('/welcome');
        }
        const queryParams = location.search;
        const examTitle = new URLSearchParams(queryParams).get('examTitle');
        if (examTitle) {
            setExamTitle(examTitle);
        }
    }, [location]);
    const submitLogin = (data) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const email = data.email;
        if (!email || !code) {
            setLoading(false);
            setCodeIsValid(false);
            return;
        }
        if ((code === null || code === void 0 ? void 0 : code.toString().length) !== 4) {
            setCodeIsValid(false);
            setLoading(false);
            return;
        }
        const sessionResponse = yield createSession(email.toLowerCase(), Number(code));
        if (sessionResponse.accessToken) {
            yield successfulLogin(sessionResponse.accessToken);
        }
        if (sessionResponse.error) {
            setCredentialsError(sessionResponse.error);
        }
        setLoading(false);
    });
    const successfulLogin = (token) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            clearCustomBranding();
            const response = yield getUser({
                variables: {
                    email: getSessionEmail(),
                },
            });
            const data = response.data;
            const accountId = (_a = data === null || data === void 0 ? void 0 : data.user) === null || _a === void 0 ? void 0 : _a.accountId;
            if (accountId) {
                // For custom branding
                saveAccountIdToStorage(accountId);
                const accountData = yield getAccountWithToken(accountId, token);
                const marketPlace = ((_c = (_b = accountData === null || accountData === void 0 ? void 0 : accountData.account) === null || _b === void 0 ? void 0 : _b.exams) === null || _c === void 0 ? void 0 : _c.marketPlace) || {};
                if (marketPlace.isEnabled) {
                    setMarketplace(marketPlace);
                }
            }
        }
        catch (error) {
            logger.error(error);
        }
        finally {
            yield validateExam();
        }
    });
    const validateExam = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield examAttemptData({
                variables: {
                    userId: getUserIdFromToken(),
                    examId: getExamIdFromToken(),
                }
            });
            const data = response.data;
            data && i18n.changeLanguage(data.examAttempt.section.language);
            if (data === null || data === void 0 ? void 0 : data.examAttempt) {
                const redirectionApplied = redirectIfCompleted(data.examAttempt);
                if (redirectionApplied) {
                    return;
                }
            }
            // This is for the new flow to start the protoring
            // DON'T DELETE 
            // Commented temporarily
            // 
            // if (data?.examAttempt.exam.isProctored) {
            //   if (!onS2bBrowser) {
            //     navigate('/no-s2b');
            //     return;
            //   }
            //   const { data } = await getS2BInformation({
            //     variables: {
            //       fields: {
            //         userId: getUserIdFromToken(),
            //         examId: getExamIdFromToken(),
            //       }
            //     }
            //   });
            //   if (!data || !data.s2bInformation) {
            //     console.error('Error getting the information for proctoring');
            //     return;
            //   }
            //   const payload = {
            //     lisPersonSourcedId: data.s2bInformation.studentId,
            //     lisPersonNameGiven: data.s2bInformation.firstName ?? '',
            //     lisPersonNameFamily: data.s2bInformation.lastName ?? '',
            //     lisPersonNameFull: data.s2bInformation.fullName ?? '',
            //     customUserLocale: data.s2bInformation.language,
            //     customUserRole: data.s2bInformation.userRoleName,
            //     customUserEmail: data.s2bInformation.email,
            //     customUserId: data.s2bInformation.studentId,
            //     customCourseId: data.s2bInformation.courseId,
            //     customCourseName: data.s2bInformation.courseName,
            //     customAssesmentName: data.s2bInformation.examName,
            //     assesmentId: data.s2bInformation.examId,
            //     isExamProctored: data.s2bInformation.isProctored,
            //     examDateRange: {
            //       from: data.s2bInformation.availableAt,
            //       to: data.s2bInformation.closingAt
            //     }
            //     // This parameters will be needed on future
            //     // registerDateRange: {
            //     //   from: ,
            //     //   to:
            //     // }
            //   };
            //   const encoded = Buffer.from(JSON.stringify(payload)).toString('base64');
            //   const s2bService = new S2BIntegrationService();
            //   s2bService.sendStartInformation(encoded);
            // } else {
            //   window.location.href = '/welcome';
            // }
            window.location.href = '/welcome';
        }
        catch (error) {
            logger.error('Error getting Exam Attempt Data', error);
            console.error('Error getting Exam Attempt Data', error);
            window.location.href = '/welcome';
        }
        return;
    });
    const handleCodeChange = (usercode) => {
        if (usercode === '') {
            setCode('');
            return;
        }
        setCodeIsValid(true);
        setCode(usercode);
    };
    return (_jsxs(LoginContainer, { children: [_jsx("img", { className: "login-logo-background", src: backgroundLogo, alt: "Sumadi logo background" }, void 0), _jsx("div", Object.assign({ className: "login-logo-container" }, { children: _jsx("img", { className: "login-logo", src: logo, alt: "Sumadi logo " }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "login-title" }, { children: [_jsx("h1", Object.assign({ className: 'd-none' }, { children: examTitle }), void 0), _jsxs("div", Object.assign({ className: "subtitle" }, { children: [" ", t('LOGIN.SUBTITLE')] }), void 0)] }), void 0), _jsxs("form", Object.assign({ id: "login", className: "login-form", onSubmit: handleSubmit(submitLogin) }, { children: [_jsxs("div", Object.assign({ className: "form-controls" }, { children: [_jsxs("label", Object.assign({ htmlFor: "email" }, { children: [t('LOGIN.EMAIL'), ":"] }), void 0), _jsx("input", Object.assign({ className: "input input--transparent", type: "text", id: "email", autoFocus: true }, register('email', {
                                required: t('GENERAL.REQUIRED_FIELD'),
                                pattern: {
                                    value: /^\S+@\S+\.\S+$/,
                                    message: t('LOGIN.INVALID_EMAIL'),
                                }
                            })), void 0), errors.email && (_jsxs("div", Object.assign({ className: "helper-message helper-message--error" }, { children: [_jsx(FontAwesomeIcon, { icon: faExclamationTriangle }, void 0), _jsxs("span", Object.assign({ className: "helper-message__text" }, { children: ["\u00A0", errors.email.message] }), void 0)] }), void 0))] }), void 0), _jsxs("div", Object.assign({ className: "form-controls" }, { children: [_jsxs("label", Object.assign({ htmlFor: "usercode" }, { children: [t('LOGIN.CODE'), ":"] }), void 0), _jsx("div", Object.assign({ className: "input-group--code" }, { children: _jsx(ReactCodeInput, { length: 4, autoFocus: false, allowedCharacters: "numeric", inputClassName: "input input--transparent input--code", onChange: handleCodeChange, ref: authInputRef }, "usercode") }), void 0), !codeIsValid && (_jsxs("div", Object.assign({ className: "helper-message helper-message--error" }, { children: [_jsx(FontAwesomeIcon, { className: "helper-icon", icon: faExclamationTriangle }, void 0), _jsxs("span", Object.assign({ className: "helper-message__text" }, { children: ["\u00A0", t('GENERAL.REQUIRED_FIELD'), " "] }), void 0)] }), void 0)), credentialsError && (_jsxs("div", Object.assign({ className: "helper-message helper-message--error" }, { children: [_jsx(FontAwesomeIcon, { className: "helper-icon", icon: faExclamationTriangle }, void 0), _jsxs("span", Object.assign({ className: "helper-message__text" }, { children: ["\u00A0", t(`LOGIN.${credentialsError}`)] }), void 0)] }), void 0))] }), void 0), _jsx("div", Object.assign({ className: "form-controls" }, { children: _jsx(Button, { className: [ButtonStyle.Fullwidth], buttonType: "submit", loading: loading, title: t('LOGIN.ENTER') }, void 0) }), void 0)] }), void 0)] }, void 0));
};
export default LoginPage;
